import * as angular from 'angular';
import { DoFinalCheckStepComponent } from './../../credit-gaps-wizard/credit-gaps-wizard-stepper/steps/do-final-check/do-final-check.component';
import { CreditGapsTransferStepperComponent } from './credit-gaps-transfer-stepper.component';
import { CreditGapsStepComponent } from './steps/credit-gaps/credit-gaps.component';
import { GradPlanningStepComponent } from './steps/grad-planning/grad-planning.component';
import { InstructionsStepComponent } from './steps/instructions/instructions.component';
import { MonitorProgramChangesStepComponent } from './steps/monitor-program-changes/monitor-program-changes.component';
import { ProgramChangesExportStepComponent } from './steps/progam-changes-export/program-changes-export.component';

export const CreditGapTransferStepperModule = angular
  .module('creditGapTransferStepperModule', [])
  .component('creditGapsTransferStepper', CreditGapsTransferStepperComponent)
  .component('creditGapsTransferInstructions', InstructionsStepComponent)
  .component('creditGapsTransferGradPlanning', GradPlanningStepComponent)
  .component('creditGapsTransferResolveGaps', CreditGapsStepComponent)
  .component('programChangesExport', ProgramChangesExportStepComponent)
  .component('monitorProgramChanges', MonitorProgramChangesStepComponent)
  .component('creditGapsTransferDoFinalCheckStep', DoFinalCheckStepComponent).name;
